import TextElement from './text_element';
import ImageElement from './image_element';
import LineElement from './line_element';

const ELEMENT_TYPES = {
  text: TextElement,
  image: ImageElement,
  line: LineElement
};

export default class ElementFactory {
  static fromData(data, managers) {
    const ElementClass = ELEMENT_TYPES[data.type];

    if (!ElementClass) {
      console.warn(`Unknown element type: ${data.type}`);
      return null;
    }

    return ElementClass.fromData(data, managers);
  }
}
